module.exports = __webpack_public_path__ + "img/文化传播类.735d0c1e.png";